const emailVerified = {
  "v-card-title": "Oops something went wrong",
  "v-card-text":
    "In order to continue you must have verified your email, please check your inbox, we already sent you an email"
};
export default emailVerified;
